export default {
  post: 'post',
  console: 'console',
  accessory: 'accessory',
  brand: 'manufacturers',
  author: 'authors',
  page: 'page',
}